/* @flow */
//
// NOTICE: can't conflict with src/createSsrRoutes
//
import React from 'react';
import { Route, Redirect } from 'react-router';

import AdminDesktopUpsellPage from 'admin/components/AdminDesktopUpsellPage.jsx';
import AdminSignupRedirect from 'admin/components/AdminSignupRedirect.jsx';
import App from 'app/components/App.jsx';
import AppLayoutContainer from 'app/containers/AppLayoutContainer.jsx';
import AppUpsellPageContainer from 'user/components/AppUpsellPageContainer.jsx';
import ConfirmEmailPage from 'auth/components/ConfirmEmailPage.jsx';
import DebugInfoView from 'misc/components/DebugInfoView.jsx';
import DeleteAccountPage from 'user/components/DeleteAccountPage.jsx';
import DepositSetupView from 'payments/components/DepositSetupView.jsx';
import EmailUnsubscribeView from 'user/components/EmailUnsubscribeView.jsx';
import ErrorView from 'app/components/ErrorView.jsx';
import ForgotPasswordPage from 'auth/components/ForgotPasswordPage.jsx';
import GetBirthdateForChat from 'chat/components/GetBirthdateForChat.jsx';
import GroupsRoutes from 'groups/routes.js';
import JoinPageTymkView from 'join/components/JoinPageTymkView.jsx';
import JoinRoutes from 'join/routes.js';
import LeaveChatView from 'chat/components/LeaveChatView.jsx';
import MarketingEmailUnsubscribeView from 'user/components/MarketingEmailUnsubscribeView.jsx';
import MarketingLayout from 'components/MarketingLayout.jsx';
import MessageView from 'messages/components/MessageView.jsx';
import NotFoundPage from 'app/components/NotFoundPage.jsx';
import OrganizationsRoutes from 'organizations/routes.js';
import ParentalConsentPage from 'user/components/ParentalConsentPage.jsx';
import QuickLinkView from 'app/components/QuickLinkView.jsx';
import ReportChatView from 'chat/components/ReportChatView.jsx';
import ResetPasswordPage from 'auth/components/ResetPasswordPage.jsx';
import SchoolView from 'schools/components/SchoolView.jsx';
import SessionExpiredPage from 'auth/components/SessionExpiredPage.jsx';
import SessionSyncPage from 'auth/components/SessionSyncPage.jsx';
import SettingsRoutes from 'settings/routes.js';
import SetupRoutes from 'setup/routes.js';
import SignInPage from 'auth/components/SignInPage.jsx';
import SignOutPage from 'auth/components/SignOutPage.jsx';
import ShareRemindPage from 'user/components/ShareRemindPage.jsx';
import TextAppLinkPage from 'user/components/TextAppLinkPage.jsx';
import TranscriptRequestApproveView from 'user/components/TranscriptRequestApproveView.jsx';
import TreasurerSignUp from 'payments/components/TreasurerSignUp.jsx';
import TreasurerAddBankAccountRouteHandler from 'payments/routerHandlers/TreasurerAddBankAccountRouteHandler.jsx';
import TreasurerLandingPage from 'payments/components/TreasurerLandingPage.jsx';
import TymkThanksView from 'user/components/TymkThanksView.jsx';
import ActivityDetailView from 'payments/components/ActivityDetailView.jsx';
import AdminRoutes from 'admin/routes.js';

import { goFromLanding, goLandingIfAuthed } from 'lib/RouteLogic';

import { RESET_PASSWORD_PATH } from 'constants/AuthConstants';

// TODO: Dynamically load routes
export default (
  <Route component={App} onEnter={App.onEnter} onChange={App.onChange}>
    {/* r101-dashboard routes */}
    <Redirect from="/" to="/landing" />
    <Redirect from="/classes/all" to="/classes/" />
    <Redirect from="/get_our_app" to="/get_the_app(/)" />
    <Redirect from="/profile" to="/settings/profile" />
    <Redirect from="/profile/widgets" to="/settings/widgets" />
    <Redirect from="/profile/exports" to="/settings/export" />
    <Redirect from="/sign_in" to="/log_in" />
    <Redirect from="/sign_out" to="/log_out" />

    {/* no layout routes */}
    <Route
      path="/transactions/deposit/setup"
      component={DepositSetupView}
      onEnter={DepositSetupView.onEnter}
    />
    <Route
      path="/landing"
      onEnter={goFromLanding}
    />

    <Route
      path="/activities/treasurer/add_bank_account(/)"
      component={TreasurerAddBankAccountRouteHandler}
    />

    <Route
      path="/activities/treasurer/join(/)"
      component={TreasurerLandingPage}
    />

    <Route component={MarketingLayout}>
      <Route path="/chat/enroll/:token" component={GetBirthdateForChat} />
      <Route
        path="/chat/report/:token"
        component={ReportChatView}
        onEnter={ReportChatView.onEnter}
      />
      <Route
        path="/chat/leave/:token"
        component={LeaveChatView}
        onEnter={LeaveChatView.onEnter}
      />
    </Route>

    <Route
      path="/activities/:id"
      component={ActivityDetailView}
      onEnter={ActivityDetailView.onEnter}
    />

    <Route component={AppLayoutContainer}>
      <Redirect from="/chat(/)" to="/classes/r/messages" />
      <Redirect from="/inbox(/)" to="/classes/r/messages" />
      <Redirect from="/chat/:chatId" to="/classes/r/messages/:chatId" />
      {GroupsRoutes}
      {SettingsRoutes}
      {OrganizationsRoutes}

      <Route
        path="/messages/:messageUuid"
        component={MessageView}
      />

      <Route
        path="/activities/:id"
        component={ActivityDetailView}
        onEnter={ActivityDetailView.onEnter}
      />

      <Redirect from="/transactions(/)" to="/classes/r/activities" />
      <Redirect from="/campaigns(/)" to="/classes/r/activities" />
      <Redirect from="/activities/new(/)" to="/classes/r/activities/new" />
    </Route>

    {AdminRoutes}

    <Route component={MarketingLayout}>
      {SetupRoutes}
      {JoinRoutes}

      <Route
        path="/activities/treasurer/sign_up(/)"
        component={TreasurerSignUp}
      />

      <Route
        path="/school/sign_up"
        component={AdminSignupRedirect}
        onEnter={AdminSignupRedirect.onEnter}
      />

      <Route path="/log_in" component={SignInPage} onEnter={goLandingIfAuthed} />
      <Route path="/session/expired" component={SessionExpiredPage} />
      <Route path="/log_out" component={SignOutPage} onEnter={SignOutPage.onEnter} />
      <Route path="/confirm_email/:token" component={ConfirmEmailPage} />
      {/*
      Users can reset password by SMS or email. SMS sends a link to
      authenticate the user that then redirects here. Email contains a link to
      /reset_password/:token that we handle in r101-frontend Node, setting a
      cookie, and then redirect here.
      */}
      <Route path={RESET_PASSWORD_PATH} component={ResetPasswordPage} />
      <Route path="/forgot_password" component={ForgotPasswordPage} />
      <Route path="/user_changed" component={SessionSyncPage} />
      {/* FIXME stop leaking token to delete user account */}
      <Route path="/delete_account/:token" component={DeleteAccountPage} />
      <Route
        path="/quicklink/:token"
        component={QuickLinkView}
        onEnter={QuickLinkView.onEnter}
      />
      <Route
        path="/email/unsubscribe/:token"
        component={EmailUnsubscribeView}
        onEnter={EmailUnsubscribeView.onEnter}
      />
      <Route
        path="/invite"
        component={JoinPageTymkView}
        onEnter={JoinPageTymkView.onEnter}
      />
      <Route path="/invite/thanks" component={TymkThanksView} />
      <Route
        path="/unsubscribe/:token"
        component={MarketingEmailUnsubscribeView}
      />

      <Route
        path="/transcript/:token"
        component={TranscriptRequestApproveView}
      />

      <Route
        path="/get_the_app"
        component={AppUpsellPageContainer}
        onEnter={AppUpsellPageContainer.onEnter}
      />

      <Route
        path="/schools_desktop"
        component={AdminDesktopUpsellPage}
        onEnter={AdminDesktopUpsellPage.onEnter}
      />

      <Route
        path="/school/:organizationId"
        component={SchoolView}
        onEnter={SchoolView.onEnter}
      />

      <Route
        path="/send_the_app"
        component={TextAppLinkPage}
      />

      <Route
        path="/parental_consent"
        component={ParentalConsentPage}
        onEnter={ParentalConsentPage.onEnter}
      />

      <Route path="/share_remind" component={ShareRemindPage} />

      <Route path="/error" component={ErrorView} />

      <Route path="/debug" component={DebugInfoView} />

      <Route path="/not_found" component={NotFoundPage} />
      <Route path="*" component={NotFoundPage} />
    </Route>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js